// extracted by css-extract-rspack-plugin
export default {"tooltip":"tooltip-rLjmUT","tooltipContent":"tooltipContent-E93bWt","menuContainer":"menuContainer-wS6wQF","menuButton":"menuButton-xvWVEh"};